module.exports = __webpack_public_path__ + "img/30c2d3fa139be86d8c59294944e82974.png";